module.exports = __webpack_public_path__ + "static/media/PathiriKallu.aa1d304c.jpg";